var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 11.411c134.992 0 244.589 109.597 244.589 244.589 0 134.992-109.597 244.589-244.589 244.589-134.992 0-244.589-109.597-244.589-244.589C11.411 121.008 121.008 11.411 256 11.411zM227.541 349.23c0-10.014 2.743-17.046 8.229-21.094 5.487-4.048 12.119-6.073 19.896-6.073 7.564 0 14.089 2.025 19.576 6.073 5.486 4.048 8.23 11.08 8.23 21.094 0 9.588-2.744 16.513-8.23 20.774-5.487 4.262-12.012 6.392-19.576 6.392-7.777 0-14.409-2.13-19.896-6.392-5.486-4.261-8.229-11.186-8.229-20.774zm47.781-54.653H236.33l-8.15-156.127h55.292l-8.15 156.127z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7ef9b8a28051beef598b396b395611b2.svg";
export { ForwardRef as ReactComponent };